module.exports = __webpack_public_path__ + "static/media/derek-bio.938f3af0.jpg";